import { CheckCircle2, Headphones, Mic, Settings2, Speaker, Timer } from "lucide-react";

const chip = "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[10px] uppercase tracking-wider";

/** What the saved setup says: mic ready, headphones / speakers, sync calibrated — with a "run setup" button. */
export default function SetupSummary({ setup, onSetup, compact = false }) {
  const ready = Boolean(setup?.ready);
  return (
    <div data-testid="rec-setup-summary" data-ready={ready ? "1" : "0"} className={`flex flex-wrap items-center gap-2 ${compact ? "" : "rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-5"}`}>
      {!compact ? (
        <p className="mr-2 font-display text-[15px] font-semibold">{ready ? "Your recording setup" : "Set up your microphone first — it takes about a minute"}</p>
      ) : null}
      {ready ? (
        <>
          <span className={`${chip} border-emerald-300/40 bg-emerald-500/10 text-emerald-100`}><CheckCircle2 className="h-3 w-3" /> Mic ready</span>
          <span className={`${chip} border-white/12 text-white/70`}>{setup.headphones ? <Headphones className="h-3 w-3" /> : <Speaker className="h-3 w-3" />} {setup.headphones ? "Headphones" : "Speakers"}</span>
          <span data-testid="rec-setup-latency" className={`${chip} border-white/12 text-white/70`}><Timer className="h-3 w-3" /> {setup.latencyMs != null ? `Sync ${setup.latencyMs} ms` : "Sync estimated"}</span>
        </>
      ) : <span className={`${chip} border-amber-300/40 bg-amber-500/10 text-amber-100`}><Mic className="h-3 w-3" /> Not set up yet</span>}
      <button type="button" data-testid="rec-open-setup" onClick={onSetup}
        className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-[12px] font-semibold transition-colors duration-200 ${ready ? "border border-white/15 bg-white/[0.05] text-white/85 hover:bg-white/[0.12]" : "bg-gradient-to-r from-rose-500 to-fuchsia-500 text-white"}`}>
        <Settings2 className="h-3.5 w-3.5" /> {ready ? "Run setup again" : "Start mic setup"}
      </button>
    </div>
  );
}
